module.exports = __webpack_public_path__ + "img/ic_twotone-arrow-back-ios-new.bfcf9f68.svg";